//@import dependencies
import React, {useState, useEffect} from 'react'
//@end

//@import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import PaginationCommon from 'app_components/commons/pagination/index';
import AlertComponent from 'app_components/commons/alert';
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form';
// @end

// @INFO Import types
import { IPortfolioProgram } from 'app_types/admin/portfolioProgram/portfolioProgram.types';
// @end

// @INFO Import services
import { PortfolioProgramService } from 'app_services/admin/portfolioProgram/portfolioProgramService';
// @end

// @INFO Import Styles
import './../portfolioModule.scss'
import InputComponent from 'app_components/commons/Input/InputComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';

// @ADD Component types
interface IPortfolioModuleLayoutProps {
  hideTitle?: boolean;
}

interface Paginator{
  page: number
  perPage: number
  total: number
}

type TypeStatusPage = 'not_loaded' | 'not_found' | 'success' | 'error' | 'loading';

const PortfolioModuleLayout: React.FC<IPortfolioModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const searchForm = useForm();
  const [paginator, updatePaginator] = useState<Paginator>({
    page: 1,
    perPage: 30,
    total: 0
  });
  const [dataSearch, updateDataSearch] = useState<any>();
  const [items, updateItems] = useState<IPortfolioProgram[]>([]);
  const [status, updateStatus] = useState<TypeStatusPage>('not_loaded');

  const portfolioProgramService = new PortfolioProgramService();

  useEffect(() => {
    handleOnSearch();
  }, [])

  useEffect(() => {
    if (paginator.page > 1) {
      handleOnSearch()
    }
  }, [paginator.page])

  const handleOnSearch = async (data?: any) => {
    updateStatus('loading');
    const response = await portfolioProgramService.list({
      ...data ? data : dataSearch,
      pageNumber: data ? 1 : paginator.page,
      nPerPage: paginator.perPage
    });
    // Actualizar el paginador y guardar los items si llega una respuesta exitosa
    if (response?.portfolioPrograms) {
      // updatePaginator(response?.pagination)
      updatePaginator({
        perPage: response.nPerPage,
        page: response.pageNumber,
        total: response.total_register
      })
      updateItems(response.portfolioPrograms);
      if (response.portfolioPrograms?.length) {
        updateStatus('success');
      } else{
        updateStatus('not_found');
      }
    } else {
      updateStatus('error')
    }
    // Guardar los datos del formulario para poder cambiar de pagina
    updateDataSearch(data);
  }

  const handleChangePage = (newPage: number) => {
    updatePaginator({
      ...paginator,
      page: newPage
    })
  }

  return(
    <div className='portfolio_module-layout'>
      {!props.hideTitle ?
      <TextComponent
        type='subtitle'
        className='title-portfolio-module'
      >
        Busca la formación que necesitas
      </TextComponent>
      :null}
      <form
        className='d-flex justify-content-end'
        style={{gap: '10px'}}
        onSubmit={searchForm.handleSubmit(handleOnSearch)}
      >
        <InputComponent
          name='search'
          placeholder='Nombre del curso o programa'
          formHook={searchForm.register()}
        />
        <InputComponent
          name='modular'
          placeholder='Modular'
          formHook={searchForm.register()}
        />
        <InputComponent
          name='code'
          placeholder='Código del programa'
          formHook={searchForm.register()}
        />
        <ButtonComponent
          variant='primary'
          type='submit'
        >
          Buscar
        </ButtonComponent>
      </form>
      {items?.length ?
      <div className="container-table-module">
        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Curso/Programa/Diplomado</th>
              <th>Horas</th>
              <th>Modular</th>
            </tr>
          </thead>
          <tbody>
            {items?.map((item) => (
              <tr
                key={item._id}
              >
                <td>{item?.code}</td>
                <td>{item?.name}</td>
                <td>{item?.hours}</td>
                <td>{item?.modular}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      :null}
      {items?.length ?
        <PaginationCommon
          data={paginator}
          onChangePage={handleChangePage}
        />
      :null}
      {status === 'not_found' ?
        <AlertComponent description='No se han encontrado elementos' type='info' />
      : null}
    </div>
  )
}

export default PortfolioModuleLayout
